import React from 'react';
import { Box, capitalizeFirstLetter, costFormater, Inscription } from '@common-fe/common-fe';

import { BankingBalancePlanDetail } from '@/modules/employer/components/BankingBalance/types';

interface Props {
  plan: BankingBalancePlanDetail;
}

const BankingBalancePlanBasicInfo: React.FC<Props> = ({ plan }) => (
  <Box data-testid="plan-basic-info" gap="spacing4">
    <Box data-testid="plan-basic-info_planYear" height="24px" direction="row" align="center" justify="between">
      <Inscription lineHeight="20px">Plan year</Inscription>
      <Inscription lineHeight="20px">{plan.planYear || '-'}</Inscription>
    </Box>
    <Box data-testid="plan-basic-info_planType" height="24px" direction="row" align="center" justify="between">
      <Inscription lineHeight="20px">Plan type</Inscription>
      <Inscription lineHeight="20px">{plan.planType || '-'}</Inscription>
    </Box>
    <Box data-testid="plan-basic-info_fundingMethod" height="24px" direction="row" align="center" justify="between">
      <Inscription lineHeight="20px">Funding method</Inscription>
      <Inscription lineHeight="20px">{capitalizeFirstLetter(plan.fundingMethod?.replace(/_/g, ' ') || '-')}</Inscription>
    </Box>
    <Box data-testid="plan-basic-info_availableBalance" height="24px" direction="row" align="center" justify="between">
      <Inscription lineHeight="20px">Available balance</Inscription>
      <Inscription lineHeight="20px">{capitalizeFirstLetter(plan.availableBalanceType?.replace(/_/g, ' ') || '-')}</Inscription>
    </Box>

    <Box height="1px" background="border2" margin={{ vertical: 'spacing4' }} />

    <Box data-testid="plan-basic-info_totalSpend" height="24px" direction="row" align="center" justify="between">
      <Inscription lineHeight="20px">Total spend</Inscription>
      <Inscription lineHeight="20px">{plan?.balances?.totalSpend ? costFormater(plan?.balances?.totalSpend, true) : '-'}</Inscription>
    </Box>
    <Box data-testid="plan-basic-info_rolledIn" height="24px" direction="row" align="center" justify="between">
      <Inscription lineHeight="20px">Rolled in</Inscription>
      <Inscription lineHeight="20px">{plan?.balances?.rolledIn ? costFormater(plan?.balances?.rolledIn, true) : '-'}</Inscription>
    </Box>
    <Box data-testid="plan-basic-info_rolledOut" height="24px" direction="row" align="center" justify="between">
      <Inscription lineHeight="20px">Rolled out</Inscription>
      <Inscription lineHeight="20px">{plan?.balances?.rolledOut ? costFormater(plan?.balances?.rolledOut, true) : '-'}</Inscription>
    </Box>
    <Box data-testid="plan-basic-info_miscTransactions" height="24px" direction="row" align="center" justify="between">
      <Inscription lineHeight="20px">Miscellaneous transactions</Inscription>
      <Inscription lineHeight="20px">{plan?.balances?.miscellaneousTransactions ? costFormater(plan?.balances?.miscellaneousTransactions, true) : '-'}</Inscription>
    </Box>
  </Box>
);

export default BankingBalancePlanBasicInfo;
